/** One-line explanations for the feedback sheet, built from the lesson's own data. */
import type { Lesson } from './content.ts';
import { allSentences } from './content.ts';
import type { AutoExercise } from './exercises.ts';
import { answerKey } from './answer.ts';

function wordGloss(lesson: Lesson, text: string): string | null {
  const key = answerKey(text);
  const word = lesson.words.find((w) => answerKey(w.word) === key);
  if (word) return `${word.word}${word.pinyin ? ` (${word.pinyin})` : ''} — ${word.ru}`;
  const expansion = (lesson.expansion ?? []).flatMap((x) => x.words).find((w) => answerKey(w.word) === key);
  return expansion ? `${expansion.word} (${expansion.pinyin}) — ${expansion.ru}` : null;
}

export function explainExercise(lesson: Lesson, ex: AutoExercise): string | null {
  const distinction = (lesson.distinctions ?? []).find((d) => d.practice.some((p) => p.id === ex.id));
  if (distinction) {
    return distinction.differences.map((d) => d.ru).join(' ') || distinction.common_ru;
  }
  switch (ex.kind) {
    case 'choice': {
      if (ex.options.every((o) => /^[A-D]$/.test(o))) return null;
      // Sentence answers (listening, «что было дальше») are explained by their translation.
      const key = answerKey(ex.correct[0] ?? '');
      const sentence = allSentences(lesson).find((s) => answerKey(s.text) === key);
      return sentence ? sentence.ru : wordGloss(lesson, ex.correct[0] ?? '');
    }
    case 'fill':
      return (
        ex.blanks
          .map((b) => wordGloss(lesson, b[0] ?? ''))
          .filter((g): g is string => g !== null)
          .join('; ') || null
      );
    case 'order':
      return null;
  }
}
